module.exports = __webpack_public_path__ + "static/media/Outlet_V2.96ccbd59.png";